import React from 'react';
import { TrendingUp, Users, Clock } from 'lucide-react';

const KeyMetrics = () => {
  const metrics = [
    {
      icon: TrendingUp,
      value: '+R$ 5 mi',
      label: 'Economizados em 90 dias por clientes como a Hurbana.',
    },
    {
      icon: Users,
      value: '+23.000',
      label: 'Fornecedores mapeados e negociados em 30 dias.',
    },
    {
      icon: Clock,
      value: '2.736 h',
      label: 'De trabalho devolvidas ao time todo mês — um ano inteiro de operação.',
    },
  ];

  return (
    <section className="relative overflow-hidden py-20 md:py-28 bg-brand-azul text-white">
      <div className="absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full bg-brand-roxo/30 blur-3xl" aria-hidden />
      <div className="absolute -bottom-32 -left-32 w-[420px] h-[420px] rounded-full bg-brand-rosa/10 blur-3xl" aria-hidden />

      <div className="container px-4 mx-auto relative z-10">
        <div className="text-center space-y-14">
          <div className="max-w-2xl mx-auto">
            <span className="inline-block text-brand-rosa font-semibold text-sm uppercase tracking-wider mb-3">
              Resultado
            </span>
            <h2 className="font-display text-3xl md:text-5xl font-extrabold leading-tight">
              Economia comprovada.
              <br />
              <span className="text-brand-rosa">Sem teoria.</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {metrics.map((metric, index) => {
              const IconComponent = metric.icon;
              return (
                <div
                  key={index}
                  className="bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl p-8 text-center hover:bg-white/10 transition-all duration-300"
                >
                  <div className="flex justify-center mb-4">
                    <div className="w-12 h-12 rounded-xl bg-brand-rosa/20 flex items-center justify-center">
                      <IconComponent className="h-6 w-6 text-brand-rosa" />
                    </div>
                  </div>
                  <div className="font-display text-4xl md:text-5xl font-extrabold text-brand-rosa mb-3">
                    {metric.value}
                  </div>
                  <p className="text-white/75 text-sm leading-relaxed">
                    {metric.label}
                  </p>
                </div>
              );
            })}
          </div>

          <p className="text-white/60 text-sm max-w-xl mx-auto">
            Estes são números reais de clientes que já operam com a dgenny.
          </p>
        </div>
      </div>
    </section>
  );
};

export default KeyMetrics;
